const Strings = {
    tituloSistema: 'DATATOX - PAINEL DE DADOS',
    nomeSistema: 'Datatox',
    prefixFooter: 'Copyright © ',
    paineis: 'Painéis',
    ambienteHomologacao: 'AMBIENTE DE HOMOLOGAÇÃO',
    disclaimerHomologacao: 'Este é um ambiente de testes. Os dados aqui apresentados podem não refletir a realidade.',
    // paginas
    paginas: {
        home: 'Início',
        seriesHistoricas: 'Séries Históricas',
        solicitante: 'Solicitante',
        dadosGeraisAtendimento: 'Dados Gerais de Atendimento',
        dadosExposicaoVitimaHumana: 'Dados Exposição Vítima Humana - Sexo e Faixa Etária',
        dadosExposicaoVitimaHumanaExposicao: 'Dados Exposição Vítima Humana - Exposição',
        dadosExposicaoVitimaHumanaEncerramento: 'Dados Exposição Vítima Humana - Encerramento',
        dadosExposicaoVitimaHumanaDadosPorGrupoDeAgentes: 'Dados Exposição Vítima Humana - Dados por Grupo de Agentes',
        dadosExposicaoVitimaHumanaDadosPorGrupoEClasseDosAgentes: 'Dados Exposição Vítima Humana - Dados por Grupo, Classe',
    },
};
const SiteLink = {
    datatox: 'https://abracit.org.br/datatox/',
};
const SiteMapInterno = {
    INICIO: '/inicio',
    SERIES_HISTORICAS: '/series-historicas',
    SOLICITANTE: '/solicitante',
    DADOS_GERAIS_ATENDIMENTO: '/dados-gerais-atendimento',
    DADOS_EXPOSICAO_VITIMA_HUMANA: '/dados-exposicao-vitima-humana',
    DADOS_EXPOSICAO_VITIMA_HUMANA_EXPOSICAO: '/dados-exposicao-vitima-humana-exposicao',
    DADOS_EXPOSICAO_VITIMA_HUMANA_ENCERRAMENTO: '/dados-exposicao-vitima-humana-encerramento',
    DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_DE_AGENTES: '/dados-exposicao-vitima-humana-dados-por-grupo-de-agentes',
    DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_E_CLASSE_DOS_AGENTES: '/dados-exposicao-vitima-humana-dados-por-grupo-e-classe-dos-agentes',
};
const MetaRoutes = [
    { title: Strings.paginas.home, href: SiteMapInterno.INICIO },
    { title: Strings.paginas.seriesHistoricas, href: SiteMapInterno.SERIES_HISTORICAS },
    { title: Strings.paginas.solicitante, href: SiteMapInterno.SOLICITANTE },
    { title: Strings.paginas.dadosGeraisAtendimento, href: SiteMapInterno.DADOS_GERAIS_ATENDIMENTO },
    { title: Strings.paginas.dadosExposicaoVitimaHumana, href: SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaExposicao, href: SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_EXPOSICAO },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaEncerramento, href: SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_ENCERRAMENTO },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoDeAgentes, href: SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_DE_AGENTES },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoEClasseDosAgentes,
        href: SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_E_CLASSE_DOS_AGENTES,
    },
];
const LinksHome = [
    { title: Strings.paginas.seriesHistoricas, href: '#series-historicas' },
    { title: Strings.paginas.solicitante, href: '#solicitante' },
    { title: Strings.paginas.dadosGeraisAtendimento, href: '#dados-gerais-atendimento' },
    { title: Strings.paginas.dadosExposicaoVitimaHumana, href: '#dados-exposicao-vitima-humana' },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaExposicao, href: '#dados-exposicao-vitima-humana-exposicao' },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaEncerramento, href: '#dados-exposicao-vitima-humana-encerramento' },
    { title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoDeAgentes, href: '#dados-exposicao-vitima-humana-dados-por-grupo-de-agentes' },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoEClasseDosAgentes,
        href: '#dados-exposicao-vitima-humana-dados-por-grupo-e-classe-dos-agentes',
    },
];
const Summaries = [
    {
        title: Strings.paginas.seriesHistoricas,
        id: 'series-historicas',
        description: `A geração de série histórica no BI DATATOX envolve a coleta contínua de dados sobre casos de exposições tóxicas e acidentes por animais peçonhentos reportados aos CIATox, o que permite a análise de tendências ao longo do tempo. Essas séries históricas são fundamentais para a saúde pública, pois oferecem subsídios valiosos sobre a eficácia de políticas de prevenção, a necessidade de programas educativos direcionados e a adequação dos recursos de saúde para o tratamento desses agravos. Além disso, permitem a identificação de novas ameaças toxicológicas emergentes e a resposta rápida a surtos de intoxicações e de envenenamentos. <br /><br />
        Na classificação utilizada dos agentes tóxicos (Agente Isolado/Associação), quando há mais de um agente envolvido em uma única ficha, estes não são discriminados, sendo computados no grupo “Associação de Grupo”.`,
        // O gráfico seria um componente separado que você pode renderizar aqui
        graph: '<GraphComponent />',
        previewUrl: './img/series-historicas512.png',
    },
    {
        title: Strings.paginas.solicitante,
        id: 'solicitante',
        description: `O solicitante consiste no indivíduo que solicita o atendimento e/ou a informação. Este geralmente é da área de abrangência de cada Centro, mas também contempla demandas oriundas de outras Unidades da Federação. Esta informação permite avaliar o alcance do serviço de cada CIATox e subsidiar o dimensionamento de pessoal do serviço.`,
        graph: '<GraphComponent />',
        previewUrl: './img/solicitante512.png',
    },
    {
        title: Strings.paginas.dadosGeraisAtendimento,
        id: 'dados-gerais-atendimento',
        description: 'Este grupo de informações inclui a distribuição de atendimentos de acordo com mês; o tipo de local que gerou a demanda de atendimento conforme; o meio pelo qual o(s) CIATox recebeu(eram) as solicitações de atendimento (que poder ser por meio telefônico, presencial ou outro) e a distribuição dos atendimentos na semana por turno, sendo eles: Turno 1 (00h00 – 05h59min); Turno 2 (06h00 – 11h59min); Turno 3 (12h00 – 17h59min) e Turno 4 (18h00 – 23h59min).',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-gerais-do-atendimento512.png',
    },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumana,
        id: 'dados-exposicao-vitima-humana',
        description: 'Aqui é disponibilizada a distribuição dos casos de exposição humana, de acordo com a classe dos agentes tóxicos. O número total de agentes não corresponde ao número total de casos de exposições humanas visto que um paciente pode associar grupos e classes diferentes de agentes em uma mesma exposição.',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-exposicao-vitima-humana-sexo-e-faixa-etaria512.png',
    },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaExposicao,
        id: 'dados-exposicao-vitima-humana-exposicao',
        description: 'As variáveis circunstância e via da exposição relacionadas aos casos de exposição humana atendidos pelos CIATox são tratadas neste painel de informações, permitindo identificar padrões de frequências das exposições a agentes tóxicos em humanos.',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-exposicao-vitima-humana-exposicao512.png',
    },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaEncerramento,
        id: 'dados-exposicao-vitima-humana-encerramento',
        description: 'Aqui temos a distribuição dos casos de exposição humana por grupo do agente causal relacionadas com a gravidade final e desfecho do caso.',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-exposicao-vitima-humana-encerramento512.png',
    },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoDeAgentes,
        id: 'dados-exposicao-vitima-humana-dados-por-grupo-de-agentes',
        description: 'Este painel contém a distribuição dos casos de exposição humana por grupo do agente causal, sendo distribuído também por faixa etária do paciente. O número total de grupos de agentes de acordo com cada grupo não corresponde ao número total de casos de exposições humanas, visto que um paciente pode associar diferentes grupos em uma mesma exposição.',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-exposicao-vitima-humana-dados-por-grupos-de-agentes512.png',
    },
    {
        title: Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoEClasseDosAgentes,
        id: 'dados-exposicao-vitima-humana-dados-por-grupo-e-classe-dos-agentes',
        description: 'Este painel contém a distribuição dos casos de exposição humana por grupo, classes e subclasses do agente causal. O número total de classes e subclasses de agentes de acordo com cada grupo não corresponde ao número total de casos de exposições humanas, visto que um paciente pode associar classes diferentes de agentes do mesmo grupo ou de diferentes grupos em uma mesma exposição.',
        graph: '<GraphComponent />',
        previewUrl: './img/dados-exposicao-vitima-humana-dados-por-grupo-e-classe-dos-agentes512.png',
    },
];
export default { Strings, SiteLink, SiteMapInterno, MetaRoutes, LinksHome, Summaries };
